import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Link, Text, Tag as UIKitTag } from '@beef/ui-kit';
import { isPlainObject } from '@beef/utils';
import { Picture } from "../Picture";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var ImageCard = /*#__PURE__*/memo(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size,
    img = _ref.img,
    title = _ref.title,
    text = _ref.text,
    button = _ref.button,
    imgLink = _ref.imgLink,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? false : _ref$bordered,
    onClick = _ref.onClick,
    backgroundColor = _ref.backgroundColor,
    _ref$borderedSizes = _ref.borderedSizes,
    borderedSizes = _ref$borderedSizes === void 0 ? ['l'] : _ref$borderedSizes,
    classes = _ref.classes,
    _ref$hasFixedAspectRa = _ref.hasFixedAspectRatio,
    hasFixedAspectRatio = _ref$hasFixedAspectRa === void 0 ? false : _ref$hasFixedAspectRa,
    tag = _ref.tag;
  var isImgLink = (imgLink === null || imgLink === void 0 ? void 0 : imgLink.link) && !(button !== null && button !== void 0 && button.link);
  var Tag = isImgLink ? 'a' : 'div';
  var withBorderOrColor = borderedSizes.includes(size) && (bordered || backgroundColor);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper', "wrapper--".concat(size), {
      card: withBorderOrColor,
      bordered: withBorderOrColor && bordered
    }, classes === null || classes === void 0 ? void 0 : classes.common),
    style: size === 'l' ? {
      backgroundColor: backgroundColor
    } : undefined,
    "data-t-id": "components-ImageCard"
  }, isPlainObject(tag) && /*#__PURE__*/React.createElement(UIKitTag, _extends({
    className: cn('tag')
  }, tag)), (img === null || img === void 0 ? void 0 : img.src) && /*#__PURE__*/React.createElement(Tag, {
    className: cn('img-wrapper', "img-wrapper--".concat(size), {
      'img--no-border': withBorderOrColor,
      'img-wrapper--has-fixed-aspect-ratio': hasFixedAspectRatio,
      link: (imgLink === null || imgLink === void 0 ? void 0 : imgLink.link) && !(button !== null && button !== void 0 && button.link)
    }),
    href: imgLink === null || imgLink === void 0 ? void 0 : imgLink.link,
    onClick: isImgLink ? onClick : undefined,
    rel: (imgLink === null || imgLink === void 0 ? void 0 : imgLink.target) === '_blank' ? 'nofollow noopener' : undefined,
    tabIndex: imgLink !== null && imgLink !== void 0 && imgLink.link ? 0 : -1,
    target: imgLink === null || imgLink === void 0 ? void 0 : imgLink.target
  }, /*#__PURE__*/React.createElement(Picture, {
    alt: img.alt,
    className: cn('img'),
    fallbackSrc: img.fallbackSrc,
    lazy: true,
    source: img.source,
    src: img.src,
    title: img.title,
    "data-t-id": "components-ImageCard"
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('details', "details--".concat(size))
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('details__content', "details__content--".concat(size))
  }, title && /*#__PURE__*/React.createElement(Text, {
    className: cn(classes === null || classes === void 0 ? void 0 : classes.title),
    size: "size4-m"
  }, title), text && /*#__PURE__*/React.createElement(Text, {
    className: cn('details__text', classes === null || classes === void 0 ? void 0 : classes.text),
    color: "grey60",
    size: "size5-r-l"
  }, text)), (button === null || button === void 0 ? void 0 : button.link) && (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/React.createElement("div", {
    className: cn('details__button')
  }, /*#__PURE__*/React.createElement(Link, {
    buttonSize: button.size || 'l',
    buttonVariant: button.variant || 'secondary',
    href: button.link,
    onClick: onClick,
    size: "size5-m",
    target: button.target || '_self',
    variant: "button"
  }, button.text))));
});
ImageCard.displayName = ImageCard.name;
export { ImageCard };